import { render, staticRenderFns } from "./DataTypeBadge.vue?vue&type=template&id=3a41d185&scoped=true&"
import script from "./DataTypeBadge.vue?vue&type=script&lang=js&"
export * from "./DataTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./DataTypeBadge.vue?vue&type=style&index=0&id=3a41d185&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41d185",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
